// Generated by ts-to-zod
import {z} from "zod";

export const mantineBarChartPropsSchema = z.object({
	h: z.number().optional(),
});
